import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const categoriesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});

const initialState = {
  categories: categoriesAdapter.getInitialState(),

  list: {
    inactiveCategories: false,
  },

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false,
    deleteWarningModal: false,
    deleteWarningModalMessage: null
  }
};

export const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.category = action.payload.category;
      state.editor.deleteConfirmationModal = false;
      state.editor.deleteWarningModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
      state.editor.deleteWarningModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    showHideDeleteWarningModal: (state, action) => {
      state.editor.deleteWarningModal = action.payload.show;
      state.editor.deleteWarningModalMessage = action.payload.message;
    },

    updateCategories: (state, action) => {
      categoriesAdapter.setMany(state.categories, action.payload.u || []);
      categoriesAdapter.removeMany(state.categories, action.payload.d || []);
    },

    toggleInactiveCategories: (state, action) => {
      state.list.inactiveCategories = !state.list.inactiveCategories;
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      categoriesAdapter.setMany(state.categories, action.payload.transactionCategories);
    });
  }
});

export const {
  showEditor: rxShowCategoryEditor,
  hideEditor: rxHideCategoryEditor,
  updateCategories: rxUpdateCategories,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal,
  showHideDeleteWarningModal: rxShowHideDeleteWarningModal,
  toggleInactiveCategories: rxToggleInactiveCategories
} = categoriesSlice.actions;

export const {selectAll: selectAllCategories} = categoriesAdapter.getSelectors(state => state.categories.categories);

export const listConfigSelector = state => state.categories.list;

export const editorConfigSelector = state => state.categories.editor;

export default categoriesSlice.reducer;
